export default "/de/katalog";
